import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';
import { errorForwardingService } from '../utils/errorForwarding';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Forward to error service
    errorForwardingService.reportComponentError(
      error,
      errorInfo.componentStack || ''
    );

    // Also log to console
    console.error('React Error Boundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '20px',
          margin: '20px',
          border: '2px solid #ef4444',
          borderRadius: '8px',
          backgroundColor: '#fee',
        }}>
          <h2 style={{ color: '#dc2626', marginTop: 0 }}>
            ⚠️ Something went wrong
          </h2>
          <p style={{ color: '#991b1b' }}>
            {this.state.error?.message || 'Unknown error'}
          </p>
          <details style={{ marginTop: '10px' }}>
            <summary style={{ cursor: 'pointer', color: '#b91c1c' }}>
              Stack trace
            </summary>
            <pre style={{
              fontSize: '12px',
              overflow: 'auto',
              padding: '10px',
              backgroundColor: '#fef2f2',
              borderRadius: '4px',
            }}>
              {this.state.error?.stack}
            </pre>
          </details>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: '15px',
              padding: '8px 16px',
              backgroundColor: '#ef4444',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
